<template>
  <div class="aed__list dea-bg-grey-light" :class="containerClass">
    <div class="grid grid--wide">
      <div v-for="(item, key) in filteredItems" :key="key" class="aed__list-item" :class="itemColumnsClasses">
        <CardService
          :heading-text="item.question"
          :title="item.minisite_title"
          :description="item.minisite_description"
          :img-src="item.services_icon_public"
          :href="item.url"
          :aria-label="`Bottone ${item.name}`"
          :bg-color="item.minisite_bg_color_public"
          :outline-color="item.minisite_outline_color_public"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CardService from "@/components/patterns/CardService";

export default {
  name: "AeDCardList",
  components: {
    CardService,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    columns: {
      type: Number,
      default: 12,
    },
  },
  computed: {
    containerClass() {
      if (this.columns !== 12) return "aed__list--full-width";
      return "";
    },
    filteredItems() {
      if (this.items) return this.items.filter(item => item.services_icon && item.services_enable);
      return [];
    },
    itemColumnsClasses() {
      if (this.columns === 9) {
        return "xs-12 l-6";
      }
      return "xs-12 s-10 off-s-1 m-6 off-m-0 l-4";
    },
  },
};
</script>

<style lang="scss"></style>
